import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/params/taxes'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {},
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {}
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          id,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
  },
}
